import { Component } from "@angular/core";

@Component({
    selector: "vds-sub-nav-toolbar",
    templateUrl: "./sub-nav-toolbar.component.html",
    styleUrl: "./sub-nav-toolbar.component.css",
    standalone: true
})
export class VdsSubNavToolbarComponent {}
